module.exports = __webpack_public_path__ + "img/downloadapp_bg.f5fa0bd.png";